import SettingsModule, {SettingsMenuTopCategory} from "../../../../../core/modules/settings-module";
import {SettingsSection, SettingsSectionTitleDict} from "../../../@const";

export default class TaskTypesSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Task Types",
            description              : "The Task Types module offers a versatile solution for customizing and managing various types of tasks within your workspace. With this module, you can create distinct task types, each with its unique settings and purposes, tailored to meet the specific needs of your workflow. These task types can be configured with different fields, workflows, and other attributes, providing a flexible framework for organizing and managing tasks across different contexts.",
            svgIcon                  : "isvg-task-types",
            settingsUrl              : "settings/task-types",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION,
            settingsSection          : SettingsSection.TASKS_PROJECTS
        });
    }

}
